import React from 'react'
import * as mapTypes from '@/propTypes/maps'
import { getCountOfStatus, getStatusOfObjects, getCountOfStatusCluster } from '@/helpers/maps'
import PieChart from '../PieChart'

import {
  ClusterContainerSmall, ClusterContainerMedium, ClusterContainerBig,
  PieChartContainerSmall, PieChartContainerMedium, PieChartContainerBig,
  PieCharOverLaySmall, PieCharOverLayMedium, PieCharOverLayBig,
  TitleSmall, TitleMedium, TitleBig,
} from './styles'

const ClusterIcon = ({ theme, intl, isMonitoring, isPassportization, features, ...ownProps }) => {
  const clusterData = getStatusOfObjects(ownProps, isMonitoring )
  const status =  isMonitoring || isPassportization ? getCountOfStatus(clusterData) : getCountOfStatusCluster(clusterData)
  let visibility = true
  if (Object.keys(ownProps).length === 0) {
    visibility = false
  }
  const { data } = status

  if (features.length <= 99) {
    return (
      <ClusterContainerSmall theme={theme} isVisible={visibility}>
        <PieChartContainerSmall theme={theme}>
          <PieChart size="small" statistic={data} theme={theme} />
        </PieChartContainerSmall>
        <PieCharOverLaySmall theme={theme}>
          <TitleSmall theme={theme}>
            {features.length}
          </TitleSmall>
        </PieCharOverLaySmall>
      </ClusterContainerSmall>
    )
  }
  if (features.length > 99 && features.length <= 999) {
    return (
      <ClusterContainerMedium theme={theme} isVisible={visibility}>
        <PieChartContainerMedium theme={theme}>
          <PieChart size="medium" statistic={data} theme={theme} />
        </PieChartContainerMedium>
        <PieCharOverLayMedium theme={theme}>
          <TitleMedium theme={theme}>
          {features.length}
          </TitleMedium>
        </PieCharOverLayMedium>
      </ClusterContainerMedium>
    )
  }

  if (features.length > 999) {
    return (
      <ClusterContainerBig theme={theme} isVisible={visibility}>
        <PieChartContainerBig theme={theme}>
          <PieChart size="big" statistic={data} theme={theme} />
        </PieChartContainerBig>
        <PieCharOverLayBig theme={theme}>
          <TitleBig theme={theme}>
          {features.length}
          </TitleBig>
        </PieCharOverLayBig>
      </ClusterContainerBig>
    )
  }
}

ClusterIcon.propTypes = {
  theme: mapTypes.theme.isRequired,
}

export default ClusterIcon
